/* eslint-disable no-inline-comments */
// @flow
import React, { Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import { NotFound } from '@finect/tabular-components/NotFound';

import { Guides, Pills, AboutFinect, LegalTerms, Terms, EthicalCode, WriteArticle, Recap2024, Recap2025 } from './scenes';

type Props = {
  location?: Object
};

class AppRouter extends React.Component<Props> {
  render() {
    return (
      <Fragment>
        <Switch>
          <Route exact path="/2024" component={Recap2024} />
          <Route exact path="/2025" component={Recap2025} />
          {/* Guides */}
          <Route exact path="/guias" component={Guides} />

          {/* Pills */}
          <Route exact path="/pildoras" component={Pills} />
          <Route exact path="/pildoras/:pill" component={Pills} />

          {/* Páginas corporativas y términos legales */}
          <Route exact path="/sobre-finect" component={AboutFinect} />
          <Route exact path="/terminos-legales" component={LegalTerms} />
          <Route exact path="/terminos-legales/:terms" component={Terms} />
          <Route exact path="/codigo-etico" component={EthicalCode} />

          {/* Escribir artículo desde perfil público */}
          <Route exact path="/usuario/:alias/articulos/nuevo" component={WriteArticle} />
          <Route exact path="/usuario/:alias/articulos/:id/editar" component={WriteArticle} />

          <Route component={NotFound} />
        </Switch>
      </Fragment>
    );
  }
}

export default AppRouter;
